<cb-dialog dialogHeading="Set Activity Supplier">
    <form class="flex-col flex" #supplierForm="ngForm">
        <span class="mat-body-strong">
            {{ mappedItem.activity?.name }}
        </span>
        <div class="start-center flex-row">
            <cb-business-account-autocomplete-scroller
                class="cb-margin-right flex"
                label="Supplier"
                name="supplierSearch"
                [(ngModel)]="selectedBusinessAccount"
                [required]="true"
                [requireMatch]="true"
                [matchProps]="['id']"
                (searchTextChanged)="businessAccountSet()"
                (optionSelected)="businessAccountSet()"
                [status]="statusQuery"
                [searchType]="searchTypeQuery"
                [tradeTypeIds]="tradeTypeIds"
            >
            </cb-business-account-autocomplete-scroller>
            <cb-business-accounts-input-find-cards
                label="Supplier"
                #businessAccountInput
                [(ngModel)]="selectedBusinessAccount"
                name="selectedSupplier"
                [buttonOnly]="true"
                (change)="businessAccountSet()"
                [searchParams]="businessAccountFindParams"
                searchTooltip="Search Suppliers matching this activity's Trade Type"
            >
            </cb-business-accounts-input-find-cards>
        </div>
        <ng-template #activityCells let-activity>
            @if (activity.isBlockActivity) {
                <td>
                    <mat-icon
                        class="cb-help-cursor"
                        svgIcon="page-layout-header"
                        ngClass="cb-grey"
                        matTooltip="Block level Activity"
                    ></mat-icon>
                </td>
            }
            @if (!activity.isBlockActivity) {
                <td>{{ activity.lotNumber > 0 ? 'Lot ' + activity.lotNumber : '-' }}</td>
            }
            <td>{{ activity.stage }}</td>
            <td>{{ activity.activityCode }}</td>
            <td>{{ activity.activity }}</td>
            <td>{{ activity.currentSupplier }}</td>
            <td>{{ activity.tradeType }}</td>
        </ng-template>
        <div>
            @if (updatableActivities.length > 0) {
                <div>
                    The following activities will also be updated to this supplier
                    <cb-table
                        class="cb-margin-bottom"
                        [minWidth]="350"
                        [maxHeightOffset]="186"
                        [loaded]="true"
                    >
                        <thead cbTableHead>
                            <tr>
                                <td>Lot#</td>
                                <td>Stage</td>
                                <td>Code</td>
                                <td>Activity</td>
                                <td>Current Supplier</td>
                                <td>Trade Type</td>
                                <td>
                                    <mat-checkbox
                                        [disabled]="!canSelectAllAffectedActivities"
                                        [checked]="allAffectedActivitiesSelected"
                                        [indeterminate]="someAffectedActivitiesSelected"
                                        (change)="toggleAllAffectedActivities($event.checked)"
                                    ></mat-checkbox>
                                </td>
                            </tr>
                        </thead>
                        <tbody cbTableBody>
                            @for (activity of updatableActivities; track activity) {
                                <tr>
                                    <ng-container
                                        *ngTemplateOutlet="activityCells; context: { $implicit: activity }"
                                    ></ng-container>
                                    <td class="start-center flex-row">
                                        <cb-checkbox
                                            [slim]="true"
                                            [(ngModel)]="activity.isSelected"
                                            [name]="'affectedActivity' + activity.id"
                                        ></cb-checkbox>
                                        @if (activity.isBlockActivity) {
                                            <mat-icon
                                                class="cb-help-cursor cb-grey"
                                                [matTooltip]="getBlockActivityTooltip(activity)"
                                                >info</mat-icon
                                            >
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </cb-table>
                </div>
            }
            @if (nonUpdatableActivities.length > 0) {
                <div class="cb-disabled">
                    The following activities cannot be updated
                    <div class="mat-caption">
                        Only able to update non-Manual Order, Incomplete (not Confirmed, Complete or
                        Abandoned) and non-Quoted Activities
                    </div>
                    <cb-table
                        class="cb-margin-bottom"
                        [minWidth]="350"
                        [maxHeightOffset]="186"
                        [loaded]="true"
                    >
                        <thead cbTableHead>
                            <tr>
                                <td>Lot#</td>
                                <td>Stage</td>
                                <td>Code</td>
                                <td>Activity</td>
                                <td>Current Supplier</td>
                                <td>Trade Type</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody cbTableBody>
                            @for (activity of nonUpdatableActivities; track activity) {
                                <tr>
                                    <ng-container
                                        *ngTemplateOutlet="activityCells; context: { $implicit: activity }"
                                    ></ng-container>
                                    <td class="start-center flex-row">
                                        <cb-checkbox
                                            [slim]="true"
                                            [disabled]="true"
                                            [ngModel]="false"
                                            [name]="'nonUpdatableActivity' + activity.id"
                                        ></cb-checkbox>
                                        <mat-icon
                                            class="cb-help-cursor cb-grey"
                                            [matTooltip]="getCannotBeUpdatedReason(activity)"
                                            >info</mat-icon
                                        >
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </cb-table>
                </div>
            }
            @if (affectedActivitiesLoaded && !foundAffectedActivities()) {
                <cb-info-message
                    message="No other activities will be affected"
                    icon="info_circle"
                    class="cb-margin"
                ></cb-info-message>
            }
        </div>
        <div class="start-center flex-row cb-margin-top">
            @if (data.lotIsPrimaryUnit) {
                <cb-checkbox
                    [slim]="true"
                    label="Apply this Supplier to same activity on the other units?"
                    [(ngModel)]="assignSameSupplierToSecondaryLot"
                    name="assignSameSupplierToSecondaryLot"
                ></cb-checkbox>
                <mat-icon
                    class="cb-help-cursor cb-grey"
                    matTooltip="Only this Activity will be updated, not the Activities selected above. Existing Suppliers on other units will be overwritten. Units are skipped if this Activity is a Manual Order or has a status of Quoted, Confirmed, Complete or Abandoned."
                    >info</mat-icon
                >
            }
        </div>
        @if (displayTradeTypesSelect) {
            <cb-select
                label="Trade Type"
                name="tradeType"
                [(ngModel)]="selectedTradeType"
                [options]="tradeTypesInSupplierAndActivity"
                [required]="true"
            ></cb-select>
        }
        @if (displaySupplyTypesSelect && featureToggleService.isSupplierTypesEnabled) {
            <cb-select
                label="Supply Type"
                name="supplyType"
                [(ngModel)]="selectedSupplyType"
                [options]="supplyTypesInSupplierAndActivity"
                [required]="true"
            ></cb-select>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="saveInProgress || setSupplierDisabled(supplierForm)"
            (click)="setSupplier()"
        >
            Confirm
        </button>
        <button mat-raised-button [disabled]="saveInProgress" (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
